import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

const Cell = ({
  className,
  column,
  row,
  style,
  placement,
  type,
  onClick,
  ...props
}) => {
  return (
    <div
      {...props}
      className={cn(styles.root, className, {
        [styles.interactive]: typeof onClick === 'function',
      })}
      data-placement={placement}
      data-type={type}
      style={{
        ...(style || {}),
        ...(column ? { '--cell-column': column } : {}),
        ...(row ? { '--cell-row': row } : {}),
      }}
    />
  );
};

export default Cell;
